import { ChangeDetectionStrategy, Component, ElementRef, HostListener, Input, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { LocalDate } from '../../store/models/local-date.model';
import { getTimezoneTextById } from '../../common/utils/date.helpers';
import { Subscription } from 'rxjs';
import { IconNames } from '../../common/constants/icon-names';
import { AutoUnsubscribe } from '../../common';
import { IntrackFeatureModule } from '../../intrack-feature.module';
import { SvgIconComponent } from '../svg-icon/svg-icon.component';

@Component({
  selector: 'ui-date-with-timezone',
  imports: [CommonModule, IntrackFeatureModule, TranslateModule, SvgIconComponent],
  templateUrl: './date-with-timezone.component.html',
  styleUrls: ['./date-with-timezone.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
@AutoUnsubscribe
export class DateWithTimezoneComponent {
  subscription: Subscription[] = [];
  @Input() set localDate(localDate: LocalDate) {
    this.date = localDate;

    if (localDate) {
      this.timezoneText = getTimezoneTextById(localDate.timezone);
    }
  }
  @Input() isEmptyStringAvailable = false;
  @Input() dateFormat: string;
  @Input() isAligningApplicable = false;

  isTextCropped: boolean;

  @ViewChild('wrapper')
  wrapperElementRef: ElementRef;

  date: LocalDate;
  timezoneText: string;
  iconNames = IconNames;

  @HostListener('mouseenter') onMouseenter(): void {
    const { offsetWidth, scrollWidth } = this.wrapperElementRef.nativeElement;
    this.isTextCropped = offsetWidth < scrollWidth;
  }
}
